import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/button-play.png';
var _withScopeId = function (n) { return (_pushScopeId("data-v-c649db5a"), n = n(), _popScopeId(), n); };
var _hoisted_1 = { class: "game-panel" };
var _hoisted_2 = { class: "game-panel-inner" };
var _hoisted_3 = { class: "leaderboard" };
var _hoisted_4 = { class: "content-wrap" };
var _hoisted_5 = { class: "content" };
var _hoisted_6 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("div", { class: "texts-wrap" }, [
    /*#__PURE__*/ _createElementVNode("span", { class: "home-title-head font-ang" }, "Miner's Rush"),
    /*#__PURE__*/ _createElementVNode("span", { class: "home-title font-ang" }, "FAQ")
], -1); });
var _hoisted_7 = { class: "col-np-12 col-np-md-12 col-np-xs-12" };
var _hoisted_8 = { class: "panel" };
var _hoisted_9 = { class: "panel-content" };
var _hoisted_10 = { class: "col-12 col-md-12 col-xs-12" };
var _hoisted_11 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("img", { src: _imports_0 }, null, -1); });
var _hoisted_12 = {
    key: 0,
    class: "box"
};
var _hoisted_13 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("img", { src: _imports_0 }, null, -1); });
var _hoisted_14 = {
    key: 1,
    class: "box"
};
var _hoisted_15 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("img", { src: _imports_0 }, null, -1); });
var _hoisted_16 = {
    key: 2,
    class: "box"
};
var _hoisted_17 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("img", { src: _imports_0 }, null, -1); });
var _hoisted_18 = {
    key: 3,
    class: "box"
};
var _hoisted_19 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("img", { src: _imports_0 }, null, -1); });
var _hoisted_20 = {
    key: 4,
    class: "box"
};
var _hoisted_21 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("img", { src: _imports_0 }, null, -1); });
var _hoisted_22 = {
    key: 5,
    class: "box"
};
var _hoisted_23 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("img", { src: _imports_0 }, null, -1); });
var _hoisted_24 = {
    key: 6,
    class: "box"
};
var _hoisted_25 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("img", { src: _imports_0 }, null, -1); });
var _hoisted_26 = {
    key: 7,
    class: "box"
};
var _hoisted_27 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("img", { src: _imports_0 }, null, -1); });
var _hoisted_28 = {
    key: 8,
    class: "box"
};
var _hoisted_29 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("img", { src: _imports_0 }, null, -1); });
var _hoisted_30 = {
    key: 9,
    class: "box"
};
var _hoisted_31 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("img", { src: _imports_0 }, null, -1); });
var _hoisted_32 = {
    key: 10,
    class: "box"
};
var _hoisted_33 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("img", { src: _imports_0 }, null, -1); });
var _hoisted_34 = {
    key: 11,
    class: "box"
};
var _hoisted_35 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("img", { src: _imports_0 }, null, -1); });
var _hoisted_36 = {
    key: 12,
    class: "box"
};
var _hoisted_37 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("img", { src: _imports_0 }, null, -1); });
var _hoisted_38 = {
    key: 13,
    class: "box"
};
var _hoisted_39 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("br", null, null, -1); });
var _hoisted_40 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("br", null, null, -1); });
var _hoisted_41 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("br", null, null, -1); });
var _hoisted_42 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("br", null, null, -1); });
var _hoisted_43 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("br", null, null, -1); });
var _hoisted_44 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("br", null, null, -1); });
var _hoisted_45 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("br", null, null, -1); });
var _hoisted_46 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("br", null, null, -1); });
var _hoisted_47 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("br", null, null, -1); });
var _hoisted_48 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("img", { src: _imports_0 }, null, -1); });
var _hoisted_49 = {
    key: 14,
    class: "box"
};
var _hoisted_50 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("img", { src: _imports_0 }, null, -1); });
var _hoisted_51 = {
    key: 15,
    class: "box"
};
var _hoisted_52 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("img", { src: _imports_0 }, null, -1); });
var _hoisted_53 = {
    key: 16,
    class: "box"
};
var _hoisted_54 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("img", { src: _imports_0 }, null, -1); });
var _hoisted_55 = {
    key: 17,
    class: "box"
};
var _hoisted_56 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("img", { src: _imports_0 }, null, -1); });
var _hoisted_57 = {
    key: 18,
    class: "box"
};
var _hoisted_58 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("img", { src: _imports_0 }, null, -1); });
var _hoisted_59 = {
    key: 19,
    class: "box"
};
var _hoisted_60 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("a", {
    class: "here-btn font-ang",
    href: "https://discord.gg/Cn2KMehEvE",
    target: "_blank"
}, "Discord", -1); });
var _hoisted_61 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("div", { class: "top-divider" }, null, -1); });
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                        _hoisted_6,
                        _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("div", _hoisted_8, [
                                _createElementVNode("div", _hoisted_9, [
                                    _createElementVNode("div", _hoisted_10, [
                                        _createElementVNode("h2", {
                                            class: _normalizeClass($data.tab == 1 ? 'open-tab-title' : ''),
                                            onClick: _cache[0] || (_cache[0] = function ($event) { return ($options.openTab(1)); })
                                        }, [
                                            _hoisted_11,
                                            _createTextVNode(" Where can I download the game? ")
                                        ], 2),
                                        ($data.tab == 1)
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_12, [
                                                _createTextVNode("The game is available "),
                                                _createElementVNode("span", {
                                                    class: "here-btn font-ang",
                                                    onClick: _cache[1] || (_cache[1] = function ($event) { return ($data.store.commit('goTo', '/play')); })
                                                }, "here"),
                                                _createTextVNode("!")
                                            ]))
                                            : _createCommentVNode("", true),
                                        _createElementVNode("h2", {
                                            class: _normalizeClass($data.tab == 2 ? 'open-tab-title' : ''),
                                            onClick: _cache[2] || (_cache[2] = function ($event) { return ($options.openTab(2)); })
                                        }, [
                                            _hoisted_13,
                                            _createTextVNode(" How do I play? ")
                                        ], 2),
                                        ($data.tab == 2)
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_14, "Miner’s Rush is a Match-3 game. Your goal is to combine 3 or more gems to destroy them and complete the level. Each level has a unique challenge, board, or goal, so make sure you pay attention to the prompts!"))
                                            : _createCommentVNode("", true),
                                        _createElementVNode("h2", {
                                            class: _normalizeClass($data.tab == 3 ? 'open-tab-title' : ''),
                                            onClick: _cache[3] || (_cache[3] = function ($event) { return ($options.openTab(3)); })
                                        }, [
                                            _hoisted_15,
                                            _createTextVNode(" Is this game beginner friendly? ")
                                        ], 2),
                                        ($data.tab == 3)
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_16, "Yes! Match-3 games are easy and fun to play. They are the perfect game for beginners!"))
                                            : _createCommentVNode("", true),
                                        _createElementVNode("h2", {
                                            class: _normalizeClass($data.tab == 4 ? 'open-tab-title' : ''),
                                            onClick: _cache[4] || (_cache[4] = function ($event) { return ($options.openTab(4)); })
                                        }, [
                                            _hoisted_17,
                                            _createTextVNode(" How long does it take to play? ")
                                        ], 2),
                                        ($data.tab == 4)
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_18, "Levels will have varying play times depending on the difficulty. The average level should take a few minutes to complete."))
                                            : _createCommentVNode("", true),
                                        _createElementVNode("h2", {
                                            class: _normalizeClass($data.tab == 5 ? 'open-tab-title' : ''),
                                            onClick: _cache[5] || (_cache[5] = function ($event) { return ($options.openTab(5)); })
                                        }, [
                                            _hoisted_19,
                                            _createTextVNode(" Does the Daily Tournament cost money? ")
                                        ], 2),
                                        ($data.tab == 5)
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_20, "Yes. The Daily Tournament requires one NFT Entry Ticket per play. These tickets are used to fund the prize pool.****"))
                                            : _createCommentVNode("", true),
                                        _createElementVNode("h2", {
                                            class: _normalizeClass($data.tab == 6 ? 'open-tab-title' : ''),
                                            onClick: _cache[6] || (_cache[6] = function ($event) { return ($options.openTab(6)); })
                                        }, [
                                            _hoisted_21,
                                            _createTextVNode(" Where can I get an NFT Entry Ticket? ")
                                        ], 2),
                                        ($data.tab == 6)
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_22, [
                                                _createTextVNode("You can buy an NFT Entry Ticket "),
                                                _createElementVNode("span", {
                                                    class: "here-btn font-ang",
                                                    onClick: _cache[7] || (_cache[7] = function ($event) { return ($data.store.commit('goTo', '/shop')); })
                                                }, "here")
                                            ]))
                                            : _createCommentVNode("", true),
                                        _createElementVNode("h2", {
                                            class: _normalizeClass($data.tab == 7 ? 'open-tab-title' : ''),
                                            onClick: _cache[8] || (_cache[8] = function ($event) { return ($options.openTab(7)); })
                                        }, [
                                            _hoisted_23,
                                            _createTextVNode(" How do I redeem my NFT Entry Ticket? ")
                                        ], 2),
                                        ($data.tab == 7)
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_24, "Connect your metamask wallet to the game. You will be prompted to redeem an NFT Entry Ticket if one is available. This action cannot be undone, so make sure you’re ready to play in that Daily Tournament before you redeem!"))
                                            : _createCommentVNode("", true),
                                        _createElementVNode("h2", {
                                            class: _normalizeClass($data.tab == 8 ? 'open-tab-title' : ''),
                                            onClick: _cache[9] || (_cache[9] = function ($event) { return ($options.openTab(8)); })
                                        }, [
                                            _hoisted_25,
                                            _createTextVNode(" How are the winners announced? ")
                                        ], 2),
                                        ($data.tab == 8)
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_26, "At the end of each day, we will confirm the Leaderboards and post the winners on our facebook, twitter, and discord"))
                                            : _createCommentVNode("", true),
                                        _createElementVNode("h2", {
                                            class: _normalizeClass($data.tab == 9 ? 'open-tab-title' : ''),
                                            onClick: _cache[10] || (_cache[10] = function ($event) { return ($options.openTab(9)); })
                                        }, [
                                            _hoisted_27,
                                            _createTextVNode(" How do I redeem my winnings? ")
                                        ], 2),
                                        ($data.tab == 9)
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_28, "Your winnings will be automatically sent to the wallet used to play the Daily Tournament."))
                                            : _createCommentVNode("", true),
                                        _createElementVNode("h2", {
                                            class: _normalizeClass($data.tab == 10 ? 'open-tab-title' : ''),
                                            onClick: _cache[11] || (_cache[11] = function ($event) { return ($options.openTab(10)); })
                                        }, [
                                            _hoisted_29,
                                            _createTextVNode(" Is there a leaderboard? ")
                                        ], 2),
                                        ($data.tab == 10)
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_30, "Yes! You can see the Tournament Leaderboard here."))
                                            : _createCommentVNode("", true),
                                        _createElementVNode("h2", {
                                            class: _normalizeClass($data.tab == 11 ? 'open-tab-title' : ''),
                                            onClick: _cache[12] || (_cache[12] = function ($event) { return ($options.openTab(11)); })
                                        }, [
                                            _hoisted_31,
                                            _createTextVNode(" Can I get an NFT Entry Ticket for free? ")
                                        ], 2),
                                        ($data.tab == 11)
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_32, "We do giveaways on our social channels. Make sure to follow us on facebook, twitter, and discord for opportunities to grab a Free NFT Entry Ticket!****"))
                                            : _createCommentVNode("", true),
                                        _createElementVNode("h2", {
                                            class: _normalizeClass($data.tab == 12 ? 'open-tab-title' : ''),
                                            onClick: _cache[13] || (_cache[13] = function ($event) { return ($options.openTab(12)); })
                                        }, [
                                            _hoisted_33,
                                            _createTextVNode(" How is the Prize Pool determined? ")
                                        ], 2),
                                        ($data.tab == 12)
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_34, "The Prize Pool is based on the number of NFT Entry Tickets redeemed. The more NFT Entry Tickets, the more competition, and the higher the Prize Pool goes!"))
                                            : _createCommentVNode("", true),
                                        _createElementVNode("h2", {
                                            class: _normalizeClass($data.tab == 13 ? 'open-tab-title' : ''),
                                            onClick: _cache[14] || (_cache[14] = function ($event) { return ($options.openTab(13)); })
                                        }, [
                                            _hoisted_35,
                                            _createTextVNode(" How big are the prizes? ")
                                        ], 2),
                                        ($data.tab == 13)
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_36, "The lowest prize is $100 USD but there is no upper limit!"))
                                            : _createCommentVNode("", true),
                                        _createElementVNode("h2", {
                                            class: _normalizeClass($data.tab == 14 ? 'open-tab-title' : ''),
                                            onClick: _cache[15] || (_cache[15] = function ($event) { return ($options.openTab(14)); })
                                        }, [
                                            _hoisted_37,
                                            _createTextVNode(" What are the prizes? ")
                                        ], 2),
                                        ($data.tab == 14)
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_38, [
                                                _createTextVNode("First Place: 70% of the Prize Pool"),
                                                _hoisted_39,
                                                _createTextVNode(" Second Place: 20% of the Prize Pool"),
                                                _hoisted_40,
                                                _createTextVNode(" Third Place: 10% of the Prize Pool"),
                                                _hoisted_41,
                                                _createTextVNode(" 4-6 Place: Free NFT Entry Ticket"),
                                                _hoisted_42,
                                                _createTextVNode(" 7-10 Place: 200 Gold Coins"),
                                                _hoisted_43,
                                                _createTextVNode(" 11-15 Place: Power Up - Miner's Cart"),
                                                _hoisted_44,
                                                _createTextVNode(" 16-20 Place: Power Up - Rainbow Pack"),
                                                _hoisted_45,
                                                _createTextVNode(" 21-25 Place: Power Up - PickAxe"),
                                                _hoisted_46,
                                                _createTextVNode(" 26-30 Place: Power Up - Shuffle"),
                                                _hoisted_47
                                            ]))
                                            : _createCommentVNode("", true),
                                        _createElementVNode("h2", {
                                            class: _normalizeClass($data.tab == 15 ? 'open-tab-title' : ''),
                                            onClick: _cache[16] || (_cache[16] = function ($event) { return ($options.openTab(15)); })
                                        }, [
                                            _hoisted_48,
                                            _createTextVNode(" How do I know someone isn’t cheating? ")
                                        ], 2),
                                        ($data.tab == 15)
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_49, "Miner’s Rush is built on CoreDAO blockchain to allow complete transparency. Creating a fun, safe, and trusting environment is of paramount importance to us."))
                                            : _createCommentVNode("", true),
                                        _createElementVNode("h2", {
                                            class: _normalizeClass($data.tab == 16 ? 'open-tab-title' : ''),
                                            onClick: _cache[17] || (_cache[17] = function ($event) { return ($options.openTab(16)); })
                                        }, [
                                            _hoisted_50,
                                            _createTextVNode(" Do you have a referral program? ")
                                        ], 2),
                                        ($data.tab == 16)
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_51, "Yes! If you have a Guild or Organization that would like to participate in Miner’s Rush, let us know here."))
                                            : _createCommentVNode("", true),
                                        _createElementVNode("h2", {
                                            class: _normalizeClass($data.tab == 17 ? 'open-tab-title' : ''),
                                            onClick: _cache[18] || (_cache[18] = function ($event) { return ($options.openTab(17)); })
                                        }, [
                                            _hoisted_52,
                                            _createTextVNode(" Are the Daily Tournament levels the same as the campaign levels? ")
                                        ], 2),
                                        ($data.tab == 17)
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_53, "No! The Daily Tournament levels are completely new every day. Players can test their skills in our campaign mode and on past tournament levels, but every day players will have a chance to beat a brand new Daily Tournament level."))
                                            : _createCommentVNode("", true),
                                        _createElementVNode("h2", {
                                            class: _normalizeClass($data.tab == 18 ? 'open-tab-title' : ''),
                                            onClick: _cache[19] || (_cache[19] = function ($event) { return ($options.openTab(18)); })
                                        }, [
                                            _hoisted_54,
                                            _createTextVNode(" What are Miner's Points? ")
                                        ], 2),
                                        ($data.tab == 18)
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_55, "Miner's Points are given to users for performing various activities in the game. They're accumulating over time and you can see them in your profile. During special events an Airdrops are announced and users recieve tokens and various rewards proportionally to Miner's Points in their account!"))
                                            : _createCommentVNode("", true),
                                        _createElementVNode("h2", {
                                            class: _normalizeClass($data.tab == 19 ? 'open-tab-title' : ''),
                                            onClick: _cache[20] || (_cache[20] = function ($event) { return ($options.openTab(19)); })
                                        }, [
                                            _hoisted_56,
                                            _createTextVNode(" How can I collect Miner's Points? ")
                                        ], 2),
                                        ($data.tab == 19)
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_57, "Miner's Points are given for playing daily tournament levels, campaign levels, minting NFT tickets, staking, watching rewarded ads and various other activities."))
                                            : _createCommentVNode("", true),
                                        _createElementVNode("h2", {
                                            class: _normalizeClass($data.tab == 20 ? 'open-tab-title' : ''),
                                            onClick: _cache[21] || (_cache[21] = function ($event) { return ($options.openTab(20)); })
                                        }, [
                                            _hoisted_58,
                                            _createTextVNode(" Where can I learn about planned Airdrops? ")
                                        ], 2),
                                        ($data.tab == 20)
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_59, [
                                                _createTextVNode("Join Miner's Rush "),
                                                _hoisted_60,
                                                _createTextVNode(" channel and follow us on social media to be the first to learn about any events!")
                                            ]))
                                            : _createCommentVNode("", true)
                                    ])
                                ])
                            ])
                        ])
                    ])
                ]),
                _hoisted_61
            ])
        ])
    ]));
}
